import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Text,
  PageActions,
  TextField,
  FormLayout,
  Select,
  Toast,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import TagsInput from "react-tagsinput";
import { validate } from "email-validator";
import { MultiSelect } from "react-multi-select-component";

export const AddContact = () => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [firstNameValue, setFirstNameValue] = useState("");
  const handleChangeFirstName = (newValue) => {
    setFirstNameValue(newValue);
    setFnError("");
  };

  const [lastNameValue, setLastNameValue] = useState("");
  const handleChangeLastName = (newValue) => {
    setLastNameValue(newValue);
    setLnError("");
  };
  const [emailValue, setEmailValue] = useState("");
  const handleChangeEmail = (newValue) => {
    setEmailValue(newValue);
    setEmailError("");
  };

  const [addressValue, setAddressValue] = useState("");
  const handleChangeAddress = (newValue) => {
    setAddressValue(newValue);
  };
  const [phoneValue, setPhoneValue] = useState("");
  const handleChangePhone = (newValue) => {
    setPhoneValue(newValue);
  };
  const [externalCampaignValue, setExternalCampaignValue] = useState("");
  const handleChangeExternalCampaign = (newValue) => {
    setExternalCampaignValue(newValue);
  };
  const [forecastValue, setForecastValue] = useState("");
  const handleChangeForecast = (newValue) => {
    setForecastValue(newValue);
  };
  const [tags, setTags] = useState([]);
  const handleChangeTags = (tags) => {
    setTags(tags);
  };
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const handleSelectChangeCategory = (value) => {
    setSelectedCategory(value);
    setCategoryError("");
  };
  const [statuses, setStatuses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const handleSelectChangeStatus = (value) => {
    setSelectedStatus(value);
    setStatusError("");
  };
  const [statusError, setStatusError] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const handleSelectChangeCampaign = (value) => {
    setSelectedCampaign(value);
    setCampaignError("");
  };

  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const handleSelectChangeCompany = (value) => {
    setSelectedCompany(value);
    setCompanyError("");
  };
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };

  const [admins, setAdmins] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState("");
  const handleSelectChangeAdmin = (value) => {
    setSelectedAdmin(value);
  };
  const [fnError, setFnError] = useState("");
  const [lnError, setLnError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [campaignError, setCampaignError] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  const handleSelectChangeMedium = useCallback(
    (value) => setSelectedMedium(value),
    []
  );
  const optionsMedium = [
    { label: "Phone", value: "1" },
    { label: "Email", value: "2" },
    { label: "Meeting", value: "3" },
  ];
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseCategories = "";
    let responseStatuses = "";
    let responseCampaigns = "";
    let responseCompanies = "";
    let responseAdmins = "";
    let responseLanguages = "";
    try {
      responseCategories = await axios.get(`/crm/categories`);
      responseCategories?.data?.data?.data &&
        setCategories(
          responseCategories?.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseStatuses = await axios.get(`/crm/statuses`);
      responseStatuses?.data?.data?.data &&
        setStatuses(
          responseStatuses.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseCampaigns = await axios.get(`/crm/campaigns`);
      responseCampaigns?.data?.data?.data &&
        setCampaigns(
          responseCampaigns.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseCompanies = await axios.get(`/crm/companies`);
      responseCompanies?.data?.data?.data &&
        setCompanies(
          responseCompanies.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseLanguages = await axios.get(`/settings/languages`);
      responseLanguages?.data?.data?.data &&
        setLanguages(
          responseLanguages.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseAdmins = await axios.get(`/management/users`);
      responseAdmins?.data?.data?.data &&
        setAdmins(
          responseAdmins?.data?.data?.data.map((item, index) => {
            return {
              label: item?.first_name
                ? item?.first_name
                : "" + item?.last_name
                ? item?.last_name
                : "",
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
  }
  const [active, setActive] = useState(false);
  const [toastContent, setToastContent] = useState("");
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  return (
    <Page
      title="Add Contact"
      narrowWidth
      backAction={{ onAction: () => navigate(`/admin/crm/contacts`) }}
    >
      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="First Name"
              value={firstNameValue}
              onChange={handleChangeFirstName}
              error={fnError}
            />
            <TextField
              label="Last Name"
              value={lastNameValue}
              onChange={handleChangeLastName}
              error={lnError}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Email"
              value={emailValue}
              onChange={handleChangeEmail}
              error={emailError}
            />
            <TextField
              label="Address"
              value={addressValue}
              onChange={handleChangeAddress}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Phone Number"
              value={phoneValue}
              onChange={handleChangePhone}
              type="number"
            />
          </FormLayout.Group>
          <Text variant="bodyMd" as="p" fontWeight="regualr">
            Tags
          </Text>
          <TagsInput value={tags} onChange={handleChangeTags} />
          <FormLayout.Group>
            <FormLayout>
              <Select
                label="Category"
                options={categories}
                onChange={handleSelectChangeCategory}
                value={selectedCategory}
                placeholder="Please select a category"
                error={categoryError}
              />
            </FormLayout>
            <FormLayout>
              <Select
                label="Status"
                options={statuses}
                onChange={handleSelectChangeStatus}
                value={selectedStatus}
                placeholder="Please select a status"
                error={statusError}
              />
            </FormLayout>
          </FormLayout.Group>

          <FormLayout.Group>
            <Select
              label="Company"
              options={companies}
              onChange={handleSelectChangeCompany}
              value={selectedCompany}
              placeholder="Please select a company"
              error={companyError}
            />
            <Select
              label="Admin"
              options={admins}
              onChange={handleSelectChangeAdmin}
              value={selectedAdmin}
              placeholder="Please select an admin"
              // error={companyError}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="External Campaign"
              value={externalCampaignValue}
              onChange={handleChangeExternalCampaign}
            />
            <TextField
              label="Forecast"
              value={forecastValue}
              onChange={handleChangeForecast}
              type="number"
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Select
              label="Language"
              options={languages}
              onChange={handleSelectChangeLanguage}
              value={selectedLanguage}
              placeholder="Please select a language"
              // error={companyError}
            />
            <Select
              label="Medium"
              options={optionsMedium}
              onChange={handleSelectChangeMedium}
              value={selectedMedium}
              placeholder="Please select"
            />
          </FormLayout.Group>
          <Text variant="bodyMd" as="p" fontWeight="regualr">
            Campaigns
          </Text>
          <MultiSelect
            options={campaigns}
            value={selectedCampaigns}
            onChange={setSelectedCampaigns}
            labelledBy="Please select campaigns"
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (
      !firstNameValue ||
      !lastNameValue ||
      !emailValue ||
      selectedCompany === "" ||
      selectedCategory === "" ||
      (!validate(emailValue) && emailValue) ||
      selectedStatus === ""
    ) {
      !firstNameValue && setFnError("This field is required");
      !lastNameValue && setLnError("This field is required");
      !emailValue && setEmailError("This field is required");
      // selectedCampaign === "" && setCampaignError("Please select a campaign");
      selectedCompany === "" && setCompanyError("Please select a company");
      selectedCategory === "" && setCategoryError("Please select a category");
      !validate(emailValue) && setEmailError("Please enter a valid email");
      selectedStatus === "" && setStatusError("Please select a status");
    } else {
      setIsSaving(true);
      const bodyObj = {
        first_name: firstNameValue,
        last_name: lastNameValue,
        email: emailValue,
        tags: tags,
        company_id: selectedCompany,
        category_id: selectedCategory,
        internal_campaigns: selectedCampaigns.map((item) => item.value),
        status_id: selectedStatus,
        address: addressValue,
        admin_id: selectedAdmin,
        forecast: forecastValue,
        language_id: selectedLanguage,
        medium: selectedMedium,
        source: "",
        external_campaign: externalCampaignValue,
        last_contacted: "",
        phone: phoneValue,
      };
      axios
        .post("/crm/contacts", bodyObj)
        .then((res) => {
          setIsSaving(false);
          navigate("/admin/crm/contacts");
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            setToastContent(error.response.data.message);
            toggleActive();
            setIsSaving(false);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};
